import { extensionDecorator, ExtensionPriority, NodeExtension } from '@remirror/core';

var _dec, _class;
var DocExtension = (_dec = /*#__PURE__*/extensionDecorator({
  defaultOptions: {
    content: 'block+'
  },
  defaultPriority: ExtensionPriority.Medium,
  staticKeys: ['content'],
  disableExtraAttributes: true
}), /*#__PURE__*/_dec(_class = class DocExtension extends NodeExtension {
  get name() {
    return 'doc';
  }
  /**
   * Create the node spec for the `doc` the content that you've provided.
   */


  createNodeSpec(_) {
    return {
      content: this.options.content
    };
  }

}) || _class);

export { DocExtension };
